import {
  ClassLessonItem,
  ClassLessonSubjectItem,
  SubjectCodeType,
} from '../../../constants/types/lms/take-class/type';
import TextWinds from '../../common/TextWinds';
import SubjectResourceRow from './SubjectResourceRow';

interface ClassLessonCardProps {
  bookCode: string;
  lesson: ClassLessonItem;
  onPptClick?: (
    lesson: ClassLessonItem,
    subject: ClassLessonSubjectItem,
  ) => void;
  onVideoClick?: (
    lesson: ClassLessonItem,
    subject: ClassLessonSubjectItem,
  ) => void;
  onSelfClick?: (
    lesson: ClassLessonItem,
    subject: ClassLessonSubjectItem,
  ) => void;
}

const SUBJECT_ORDER: SubjectCodeType[] = ['ESB', 'EF', 'EC', 'MATERIAL'];

/**
 * 개편 LMS (교사) - 수업하기 페이지 > 북별 레슨 판넬 > 레슨 목록 > 레슨 카드
 */
const ClassLessonCard = ({
  bookCode,
  lesson,
  onPptClick,
  onVideoClick,
  onSelfClick,
}: ClassLessonCardProps) => {
  const sortedSubjects = [...lesson.subjects].sort(
    (a, b) =>
      SUBJECT_ORDER.indexOf(a.subjectCode) -
      SUBJECT_ORDER.indexOf(b.subjectCode),
  );

  return (
    <article className="grid min-h-[120px] overflow-hidden rounded-xl border border-gray2 bg-white shadow-sm xl:grid-cols-[130px_1fr]">
      <div className="flex items-center justify-center bg-[#6B5ADD] px-4 py-3 text-center xl:min-h-[120px] xl:py-5">
        <div className="flex items-center justify-center gap-2 xl:flex-col xl:gap-0">
          <TextWinds
            type="content_body1"
            color="white"
            className="break-keep font-bold leading-snug"
          >
            {lesson.lesson}
          </TextWinds>
        </div>
      </div>

      <div
        className="grid"
        style={{
          gridTemplateRows: `repeat(${sortedSubjects.length}, minmax(0, 1fr))`,
        }}
      >
        {sortedSubjects.map((subject, index) => (
          <SubjectResourceRow
            key={`${lesson.lesson}-${subject.subjectCode}-${index}`}
            bookCode={bookCode}
            lesson={lesson}
            subject={subject}
            onPptClick={onPptClick}
            onVideoClick={onVideoClick}
            onSelfClick={onSelfClick}
          />
        ))}
      </div>
    </article>
  );
};

export default ClassLessonCard;
